import styled from "styled-components";
import theme from "common/theme";


const pointerSize = 10;
const pointerOffset = pointerSize - 5;
const svgMarkup = `<svg  class="tooltip-marker arrow-icon" width="${pointerSize}" height="${pointerSize}" viewBox="0 0 ${pointerSize} ${pointerSize}" xmlns="http://www.w3.org/2000/svg">
  <polygon className="poly" points="${
    pointerSize / 2
  },0 ${pointerSize},${pointerSize} 0,${pointerSize}" fill="white" />
</svg>`;

// Encode the SVG string
const encodedSvg = encodeURIComponent(svgMarkup);


/*
 &[data-area="left top"] {
    &.contained-quadrants {
      transform: translateX(10px) translateY(0);
      transition: transform .4s ease;
    }
  }
  &[data-area="right top"] {
    &.contained-quadrants {
      transform: translateX(calc(-100% - 5px)) translateY(0);
      transition: transform .4s ease;
    }
  }
  &[data-area="right bottom"] {
    &.contained-quadrants {
      transform: translateX(calc(-100% - 5px)) translateY(-100%);
      transition: transform .4s ease;
    }
  }
  &[data-area="left bottom"] {
    &.contained-quadrants {
      transform: translateX(10px) translateY(-100%);
      transition: transform .4s ease;
    }
  }
  
  &[data-position="left"] {
  &.opposite-direction {
    transform: translate(calc(-100% - 10px), -50%);
    transition: transform .4s linear;
}}
  &[data-position="right"] {
  &.opposite-direction {
    transform: translate(20px, -50%);
    transition: transform .4s linear;
}}
  &[data-position="top"] {
  &.opposite-direction {
    transform: translate(-50%, calc(-100% - 10px));
    transition: transform .2s linear;
}
  }
  &[data-position="bottom"] {
  &.opposite-direction {
    transform: translate(-50%, 25px);
    transition: transform .2s linear;
}
  }



const barTooltip = `
  height: 30px;
  background: blue;

  .tooltip__inner {
    transform: translatex(0) translateY(0);
    &:after {
      top: calc(50% - 5px);
    }
  }

  &[data-direction*="right"] {
    .tooltip__inner {
      transform: translateX(calc(-100% - 15px)) translateY(-50%);
      &:after {
        left: calc(100% - 2px);
        right: auto;
        transform: rotate(90deg);
      }
    } 
  }
    
  &[data-direction*="left"] {
    .tooltip__inner {
      transform: translateX(15px) translateY(-50%);
      &:after {
        right: calc(100% - 2px);
        left: auto;
        transform: rotate(-90deg);
      }
    } 
  }
  

`
const areaTooltip = `

  .tooltip__inner { 
    transition: transform .2s ease;

    &:after { display: none; }
  }


  &[data-area="left top"] { 
    .tooltip__inner {
      transform: translateX(20px) translateY(-10px);
    }
  }

  &[data-area="left bottom"] {
    .tooltip__inner {
      transform: translateX(20px) translateY(-100%);
    }
  }

  &[data-area="right top"] { 
    .tooltip__inner {
      transform: translateX(calc(-100% - 10px)) translateY(-10px);
    }
  }

  &[data-area="right bottom"] {
    .tooltip__inner {
      transform: translateX(calc(-100% - 10px)) translateY(-100%);
    }
  }
`
*/
// classnames
// contained-columns snaps to date nearest x y data point
// area-tooltip follows the cursor but repositions the tooltip to follow the cursor and stay with the chart area
export const GeneratorChartTooltipContainer = styled.div<{color?: string}>`


  width: 0px;
  height: 0px;
  
  flex-direction: column;
  align-items: center;
  font-size: .8em;
  position: absolute;
  left: 0;
  top: 0;
  transform: translateY(-${pointerSize}px);
  &.default {
    .tooltip__inner {  
      transform: translateX(-50%) translateY(-100%);
    }
  }
 
  .tooltip__inner {

    display: flex;
    flex-direction: column;
    padding: .5em;
    background-color: white;
    width: max-content;
    box-shadow: ${theme.effects.boxShadow.tooltip};
    border-radius: 5px;

    &:after {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      left: 50%;
      top: 100%;
      transform: translate(-50%, -1px) rotate(180deg);
      background-image: url('data:image/svg+xml,${encodedSvg}');
      background-size: contain;
      background-repeat: no-repeat;
      background-color: transparent;

      filter: drop-shadow(0 -3px 2px rgba(0, 0, 0, 0.3));
    }
  }
  
  .label {
    color: ${theme.colors.label};
  }

  strong.black {
    color: black;
  }
  .tooltip__title {
    white-space: nowrap;
    font-weight: 600;
    font-size: 1.1em;
    margin-bottom: 0.3em;
    padding-bottom: 0.3em;
    border-bottom: solid 1px rgba(0, 0, 0, 0.2);
  }
  
  .small {
    font-size: .85em;
    font-weight: 500;
  }

  .padding-top { padding-top: .3em }
  .padding-bottom { padding-bottom: .3em }

  .tooltip__value {
    text-transform: capitalize;
    min-width: max-content;
  }

  .centered-text {
    text-align: center;
  }

  .row {
    margin-top: .5em;
  }

  .tooltip__group {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    grid-gap: 0.3em;
    text-transform: capitalize;
    align-items: center;
    margin-bottom: .3em;
    
    .value {
      font-weight: 600;
    }
    
    &:not(.inline):before, .color-icon {
      display: block;
      content: '';
      width: .7em;
      height: .7em;
      border-radius: 50%; 
      transform: translateY(-.08em);        
    }
  }

  .groups {
    display: flex;
    flex-direction: column;
    gap: 0.3em;
  }

  

  

 


`
export const colTemplate = `

  &[data-area="left top"] { }
  &[data-area="right top"] { }
  &[data-area="right bottom"] { }
  &[data-area="left bottom"] { }
  
  &[data-position="left"] { }
  &[data-position="right"] { }
  &[data-position="top"] { }
  &[data-position="bottom"] { }

  

`